import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { ProcessService } from '../services/process.service';
import { map, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../store';
import * as fromProcess from '../store/process/process.selectors';

@Injectable({
  providedIn: 'root',
})
export class DirectAppGuard {
  processKind$ = this.store.select(fromProcess.selectProcessKind);

  constructor(private store: Store<AppState>, private processService: ProcessService, private router: Router) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    return this.processKind$.pipe(
      map((processKind) => {
        const url = next.url.map(({ path }) => path).join('/');
        const isSuccessPage = url.includes('success');

        if (isSuccessPage) {
          return true;
        }

        if (!processKind) {
          void this.router.navigate(['page', 'step1']);

          return false;
        }

        return true;
      }),
    );
  }
}
